<template>
    <transition>
        <div>
            <el-form :model="formData" :rules="formRules" ref="formRef" @submit.native.prevent>
                <div class="inline-form">
                    <el-form-item prop="firstName" class="inline-form-item">
                        <el-input v-model="formData.firstName" :placeholder="$t('first_name')"></el-input>
                    </el-form-item>
                    <el-form-item prop="lastName" class="inline-form-item">
                        <el-input v-model="formData.lastName" :placeholder="$t('last_name')"></el-input>
                    </el-form-item>
                </div>
                <el-form-item prop="account">
                    <el-input v-model="formData.account" :placeholder="$t('email')"></el-input>
                </el-form-item>
                <input type="text" style="display:none;" />
                <input type="password" style="display:none;" />
                <el-form-item prop="password">
                    <el-input
                        v-model="formData.password"
                        :placeholder="$t('login_password_as')"
                        :type="formData.type"
                    >
                        <i
                            class="iconfont show-pass-icon"
                            :class="[formData.type === 'password' ? 'icon-icon_visiblex' : 'icon-icon_invisiblex']"
                            slot="suffix"
                            @click="toggleShowPasswd(formData)"
                        ></i>
                    </el-input>
                </el-form-item>
                <p class="term-tips">
                    {{$t('joinTips')}}
                    <span class="spec-text" @click="termsUse">{{$t('termsUse')}}</span>
                    , {{$t('and')}}
                    <span
                        class="spec-text"
                        @click="policy"
                    >{{$t('privacy_policy')}}</span>
                </p>
                <button class="form-btn" @click="confirm">{{$t('confirm')}}</button>
            </el-form>
        </div>
    </transition>
</template>

<script>
import { signupGtag } from "@/lib/gtag.js";

export default {
    data() {
        const validatePass = (rule, value, callback) => {
            if (value.length < 6 || value.length > 15) {
                callback(new Error(this.$t("passwd_string_length")));
            } else {
                callback();
            }
        };
        return {
            formData: {
                firstName: "",
                lastName: "",
                account: "",
                password: "",
                type: "password"
            },
            formRules: {
                firstName: [
                    {
                        required: true,
                        message: this.$t("first_name_error"),
                        trigger: "none"
                    }
                ],
                lastName: [
                    {
                        required: true,
                        message: this.$t("last_name_error"),
                        trigger: "none"
                    }
                ],
                account: [
                    {
                        required: true,
                        message: this.$t("email_error"),
                        trigger: "none"
                    },
                    {
                        type: "email",
                        message: this.$t("email_error"),
                        trigger: "none"
                    }
                ],
                password: [
                    {
                        required: true,
                        message: this.$t("reinput_passwd"),
                        trigger: "none"
                    },
                    {
                        validator: validatePass,
                        trigger: "none"
                    }
                ]
            }
        };
    },
    methods: {
        confirm() {
            this.$refs["formRef"].validate(valid => {
                if (!valid) {
                    // this.$message('请检查您的表单', 'error')
                    return;
                }
                this.$req
                    .post("register", {
                        account: this.formData.account,
                        password: this.formData.password,
                        first_name: this.formData.firstName,
                        last_name: this.formData.lastName,
                        register_type: 1
                    })
                    .then(({ data }) => {
                        //埋点
                        signupGtag({
                            姓名:
                                this.formData.firstName +
                                "/" +
                                this.formData.lastName,
                            "邮箱/手机": this.formData.account,
                            用户ID: data.data.user_id || ""
                        });
                        if (data.code === "2000") {
                            //修改登录状态
                            this.$store.dispatch(
                                "updateToken",
                                data.data.token
                            );
                            this.$store.dispatch("updateUser", data.data);
                            this.$store.dispatch(
                                "updateAvatar",
                                data.data.user_info.extend.avatar
                            );

                            //关闭当前页面
                            this.$store.dispatch("toggleShowSignup", false);

                            this.resetFields();
                        } else {
                            this.$msg.error(data.msg);
                        }
                    });
            });
        },
        resetFields() {
            this.$refs["formRef"].resetFields();
        },
        toggleShowPasswd(form) {
            if (form.type === "password") {
                form.type = "text";
            } else {
                form.type = "password";
            }
        },
        termsUse() {
            this.$store.dispatch("toggleShowSignup", false);
            this.$router.push({ name: "Conditions" });
        },
        policy() {
            this.$store.dispatch("toggleShowSignup", false);
            this.$router.push({ name: "Policy" });
        }
    }
};
</script>

<style>
.inline-form {
    display: flex;
    justify-content: space-between;
}
.inline-form > .inline-form-item {
    width: 48%;
}
</style>



// WEBPACK FOOTER //
// src/views/Public/SignUp/Email.vue